import { useClassName } from '@/styles/CoverBox';
import { Component, ComponentProps } from '@/types/component';
import mergeProps from 'lib/utils/mergeProps';

export type CoverBoxExpandProps = ComponentProps<'span'>;

export const CoverBoxExpandComponent: Component<CoverBoxExpandProps> = ({ children, ...props }) => {
  const className = useClassName('expand', props);

  return <span {...mergeProps({ className }, props)}>{children}</span>;
};
